import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCaseStyles } from "../../api/CatalogAPIs";
import {
  CASE_STYLE_FILTER_ALL,
  CASE_STYLE_FILTER_NORMAL,
  orderMatchesCaseStyleFilter,
  specialCaseStyleLabels,
} from "../../utils/orderLineDisplay";

const accents = {
  indigo: {
    active: "bg-indigo-600 text-white shadow-md",
    idle: "bg-gray-100 text-gray-700 hover:bg-gray-200",
  },
  purple: {
    active: "bg-purple-600 text-white shadow-md",
    idle: "bg-gray-100 text-gray-700 hover:bg-gray-200",
  },
};

const CaseStyleOrderFilter = ({ value, onChange, orders = [], accent = "indigo" }) => {
  const { data: styles = [] } = useQuery({
    queryKey: ["catalogCaseStyles"],
    queryFn: fetchCaseStyles,
    staleTime: 5 * 60 * 1000,
  });

  const options = useMemo(() => {
    const specials = specialCaseStyleLabels(styles, orders);
    return [
      { value: CASE_STYLE_FILTER_ALL, label: "الكل" },
      { value: CASE_STYLE_FILTER_NORMAL, label: "عادي" },
      ...specials.map((name) => ({ value: name, label: name })),
    ];
  }, [styles, orders]);

  const colors = accents[accent] || accents.indigo;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-gray-100">
      <span className="text-sm text-gray-600">نوع الكفر:</span>
      {options.map((option) => {
        const count = orders.filter((order) => orderMatchesCaseStyleFilter(order, option.value)).length;
        const active = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            title={
              option.value === CASE_STYLE_FILTER_NORMAL
                ? "طلبات بدون نوع كفر، أو شفاف فقط"
                : undefined
            }
            className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${
              active ? colors.active : colors.idle
            }`}
          >
            {option.label}
            <span className={`mr-1 text-xs ${active ? "text-white/80" : "text-gray-500"}`}>({count})</span>
          </button>
        );
      })}
    </div>
  );
};

export default CaseStyleOrderFilter;
